import { AuthGuard, CmsConfig, ParamsMapping, RoutingConfig } from '@spartacus/core';
import {
  ActiveLinkCellComponent,
  CellComponent,
  ItemService,
  OrganizationTableType,
  RolesCellComponent,
  StatusCellComponent,
  UserChangePasswordFormComponent,
  UserItemService,
} from '@spartacus/organization/administration/components';

import { TableConfig } from '@spartacus/storefront';
import { KnBrAdminGuard } from 'src/shared/guards/kn-br-admin.guard';
import { KnBrListService } from './shared/kn-br-list/kn-br-list.service';
import { KnBrStaffCustomerTabsComponent } from './shared/kn-br-staff-customer-tabs/kn-br-staff-customer-tabs.component';
import { KnBrUserFormComponent } from './users/kn-br-add-user-form/kn-br-user-form.component';
import { KnBrUserDetailsComponent } from './users/kn-br-user-details/kn-br-user-details.component';
import { KnBrUserListService } from './users/services/kn-br-user-list.service';

const listPath = `users/:userCode`;
const paramsMapping: ParamsMapping = {
  userCode: 'customerId',
};

export const knBrUserRoutingConfig: RoutingConfig = {
  routing: {
    routes: {
      orgUser: {
        paths: ['users'],
      },
      orgUserCreate: {
        paths: ['users/create'],
      },
      orgUserDetails: {
        paths: [listPath],
        paramsMapping,
      },
      orgUserEdit: {
        paths: [`${listPath}/edit`],
        paramsMapping,
      },
      orgUserChangePassword: {
        paths: [`${listPath}/change-password`],
        paramsMapping,
      },
    },
  },
};

export const knBrUserTableConfig: TableConfig = {
  table: {
    [OrganizationTableType.USER]: {
      cells: ['name', 'uid', 'roles', 'active'],
      options: {
        cells: {
          name: {
            dataComponent: ActiveLinkCellComponent,
          },
          uid: {
            dataComponent: CellComponent,
          },
          roles: {
            dataComponent: RolesCellComponent,
          },
          active: {
            dataComponent: StatusCellComponent,
          },
        },
      },
    },
  },
};

export const knBrUserCmsConfig: CmsConfig = {
  cmsComponents: {
    ManageUsersListComponent: {
      component: KnBrStaffCustomerTabsComponent,
      providers: [
        {
          provide: KnBrListService,
          useExisting: KnBrUserListService,
        },
        {
          provide: ItemService,
          useExisting: UserItemService,
        },
      ],
      childRoutes: {
        children: [
          {
            path: 'create',
            component: KnBrUserFormComponent,
          },
          {
            path: `:userCode`,
            component: KnBrUserDetailsComponent,
            data: {
              cxPageMeta: { breadcrumb: 'orgUser.breadcrumbs.details' },
            },
          },
          {
            path: `:userCode/edit`,
            component: KnBrUserFormComponent,
          },
          {
            path: `:userCode/change-password`,
            component: UserChangePasswordFormComponent,
          },
        ],
      },
      guards: [AuthGuard, KnBrAdminGuard],
    },
  },
};
